export const RESET_BUDGET_REDUCER = "RESET_BUDGET_REDUCER";
export const SET_BUDGET_TRANSACTIONS = "SET_BUDGET_TRANSACTIONS";
export const SET_EDIT_DATA = "SET_EDIT_DATA";
export const RESET_EDIT_DATA = "RESET_EDIT_DATA";
